"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="services-overview" className="relative py-20 md:py-28 overflow-hidden bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1443870/img/team_conference_strategic_planning.png)]">
      <div className="absolute inset-0 bg-background/92" />
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={ref} className={cn("mx-auto max-w-3xl text-center transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-8 tracking-tight">
            Strategic Growth Services
          </h1>
          
          <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed">EduStrategy Group helps colleges and universities not just survive but thrive. We bridge the gap between today’s challenges and tomorrow’s opportunities by co- creating strategies and executing alongside your teams. We co-design lifelong learning ecosystems that build internal capability, not external dependency. Our services are tailored for mission-driven institutions ready to grow on their own terms, embedding capacity inside your organization so the growth you achieve is growth you own.</p>
        </div>

        <div className={cn("mt-20 md:mt-28 max-w-5xl mx-auto transition-all duration-1000 delay-300 ease-out", isVisible ? "opacity-100 scale-x-100" : "opacity-0 scale-x-0")}>
          <Separator className="bg-border/60" />
        </div>
      </div>
    </section>;
}